<template>
  <div class="fd-header flex-col">
    <div class="header-content flex-col">
      <el-carousel :interval="periods * 1000" height="600px">
        <el-carousel-item v-for="item in imgs" :key="item.id">
          <img
            :src="item"
            style="object-fit: cover; width: 100%; height: 600px"
          />
        </el-carousel-item>
      </el-carousel>
      <div class="search-box">
        <TimeBox></TimeBox>
        <div style="flex: 1">
          <div class="block-theme flex-row">
            <div
              :class="
                themeId == item.id
                  ? 'selected-theme search-theme flex-col'
                  : 'flex-col search-theme'
              "
              v-for="item in searchTheme"
              :key="item.id"
              @click="selectTheme(item.id)"
            >
              <span class="search-title">{{ item.name }}</span>
              <div class="box_1 flex-col"></div>
            </div>
          </div>
          <div v-if="themeId == 1">
            <HldTheme></HldTheme>
          </div>
          <div v-if="themeId == 2">
            <DocTheme></DocTheme>
          </div>
          <div v-if="themeId == 3">
            <DataTheme></DataTheme>
          </div>
          <div v-if="themeId == 4">
            <ESTheme></ESTheme>
          </div>
          <div v-if="themeId == 5">
            <LoginTheme></LoginTheme>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { get } from "@u/request";
import HldTheme from "./HldTheme";
import DocTheme from "./DocTheme";
import DataTheme from "./DataTheme";
import ESTheme from "./ESTheme";
import LoginTheme from "./LoginTheme";
import TimeBox from "./TimeBox";

export default {
  name: "DSF",
  components: {
    HldTheme,
    DocTheme,
    DataTheme,
    ESTheme,
    LoginTheme,
    TimeBox,
  },
  props: {
    copyright: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      drawer: false,
      themeId: 1,
      searchTheme: [
        {
          id: 1,
          name: "馆藏目录",
        },

        {
          id: 3,
          name: "数据库",
        },
        {
          id: 4,
          name: "电子期刊",
        },
        {
          id: 2,
          name: "电子图书",
        },
        {
          id: 5,
          name: "我的图书馆",
        },
      ],
      imgs: [],
      periods: 5,
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.isPosition = to.path === "/home";
      },
      immediate: true,
    },
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    toHome() {
      this.$router.push("/home");
    },
    selectTheme(id) {
      this.themeId = id;
    },
    async getConfig() {
      const { data } = await get("lib/consult/getConfig");
      const config = data[0];
      if (config) {
        this.imgs = config.images ? config.images.split(",") : [];
        this.periods = config.periods || 5;
      }
    },
  },
  mounted() {
    this.getConfig();
  },
};
</script>

<style scoped lang="scss">
.fd-header {
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  // min-width: 1920px;
  width: 100%;
  .header-content {
    // background-image: url(../../assets/index.png);
    height: 600px;
    background-size: 100% 100%;
    ::v-deep {
      .el-carousel__indicators--horizontal {
        left: 3%;
      }
    }
  }
}

.search-box {
  box-shadow: 0px 12px 22px -4px rgba(0, 42, 88, 0.2);
  background-color: rgba(249, 252, 255, 1);
  border-radius: 0px 0px 0px 2px;
  // position: absolute;
  // left: 500px;
  // top: 445px;
  // width: calc(100% - 500px);
  width: 1400px;
  margin: -123px auto;
  // height: 235px;
  z-index: 2;
  display: flex;
  .block-theme {
    // width: 1071px;

    height: 62px;
    // margin-left: 224px;
    .search-theme {
      flex: 1;
    }
    .search-title {
      height: 22px;
      overflow-wrap: break-word;
      color: rgba(0, 72, 150, 1);
      font-size: 22px;
      white-space: nowrap;
      line-height: 33px;
      margin: 14px auto;
      text-align: center;
      cursor: pointer;
      // width: 200px;
      font-weight: 700;
    }

    .selected-theme {
      // width: 200px;
      height: 80px;
      cursor: pointer;
      background: url(../../assets/search-bg-select.png) 0px 0px no-repeat;
      background-size: 100% 100%;
      .search-title {
        color: #fff;
      }
      .box_1 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 1px;
        width: 30px;
        height: 3px;
        margin: auto;
        margin-top: -2px;
      }
    }
  }
}
</style>
